import { PlayerReducerActions } from '@/modules/player/providers/PlayerProvider.types';
import { usePlayerDispatch } from '@/modules/player/providers/PlayerProvider';
import { useCallback } from 'react';

export const usePlayerDuration = () => {
  const dispatch = usePlayerDispatch();

  const handleDuration = useCallback(
    (duration: number) => {
      dispatch({ type: PlayerReducerActions.HANDLE_DURATION, payload: { duration } });
    },
    [dispatch]
  );

  return handleDuration;
};
